import Dropzone from 'react-dropzone';
import styled from 'styled-components';
import { Container } from '@riac/design-system';

export const ConsignmentGettingStartedContainer = styled(Container)`
  max-width: 750px;
  flex-direction: column;
`;

export const PhotoOptions = styled.ol`
  list-style: inside number;
  li {
    margin-top: 15px;
  }
`;

export const ConsignmentDropzone = styled(Dropzone)`
  width: 100%;
  max-width: 600px;
  height: 240px;
  border: 3px dashed ${(props) => props.theme.black[70]};
  border-radius: 10px;
  padding: 20px;
  text-align: center;
  min-height: 240px;
  height: auto;
  margin: 10px;
`;

export const UploadedConsignmentFile = styled.div<{completed: boolean}>`
  background-color: ${(props) => props.theme.black[90]};
  border: 2px dashed ${(props) => props.theme.black[85]};
  border-radius: 3px;
  padding: 2px;
  font-size: 1.25rem;
  line-height: 3.5;
  margin: 1rem 0;
  ${(props) => props.completed ? `
    border: 2px dashed rgba(50, 255, 50, 1);` : ''}
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const FilePreview = styled.div`
  width: 70px;
  height: 70px;
  overflow: hidden;
  position: relative;
  background-color: white;
  border: 1px solid black;
  border-radius: 2px;
  float: left;

  img {
    margin-top: 50%;
    transform: translateY(-50%);
    position: absolute;
    left: 0;
    right: 0;
    width: 70px;
  }
`;
